import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';
import { pageChildBannerStyles } from 'pages/usage/usage.style';

const cardAttrs = () => ({
  mobileVariant: 'flat',
});

export const Banner = styled(Card).attrs(cardAttrs)`
  align-items: center;
  background: ${props => props.theme.colors.background.primaryInverse};
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 24px 64px;

  ${props => props.theme.media.small`
    padding: 32px;
    ${pageChildBannerStyles}
  `}
`;
